module.exports = __webpack_public_path__ + "img/16.3.TP.d0a7e6d2.png";